// extracted by mini-css-extract-plugin
module.exports = {"section":"Campsites_section__Z0z7G","paragraph":"Campsites_paragraph__w9hVs","icon":"Campsites_icon__q_u7r"};